import { render, staticRenderFns } from "./TestWidgetWithoutIcon.vue?vue&type=template&id=02413e06&"
import script from "./TestWidgetWithoutIcon.vue?vue&type=script&lang=js&"
export * from "./TestWidgetWithoutIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports